import { Box, Checkbox, Skeleton } from "@mui/material";

import {
  avatarStyle,
  checkboxStyle,
  verificationIconStyle,
  getCardWrapperStyle,
  getCardContentStyle,
  getTypographyStyles,
} from "./styles";

interface UserCardLoaderProps {
  variant?: "list" | "grid" | "trending";
  showCheckbox?: boolean;
}

const UserCardLoader = ({ variant = "list", showCheckbox = false }: UserCardLoaderProps) => {
  const typographyStyles = getTypographyStyles({ variant });

  return (
    <Box sx={getCardWrapperStyle({ variant })}>
      {showCheckbox && <Checkbox size="small" sx={checkboxStyle[variant]} disabled checked={false} />}

      <Box sx={{ position: "relative" }}>
        <Skeleton variant="circular" sx={avatarStyle[variant]} />
        <Skeleton variant="circular" width={16} height={16} sx={verificationIconStyle[variant]} />
      </Box>

      <Box sx={getCardContentStyle({ variant })}>
        <Box
          sx={{
            display: "flex",
            columnGap: "3px",
            width: "100%",
            minWidth: 0,
            alignItems: "center",
            marginBottom: "5.5px",
            justifyContent: "center",
          }}
        >
          <Skeleton variant="text" width={variant === "grid" ? "80%" : "95%"} height={24} />
          <Skeleton variant="rectangular" width={12} height={9} />
        </Box>

        <Skeleton variant="text" width={variant === "grid" ? "60%" : "70%"} sx={typographyStyles.roleClub} />

        <Skeleton
          variant="text"
          width={variant === "grid" ? "80%" : "90%"}
          sx={typographyStyles.mutualFollowersAndFriendsCount}
        />

        {variant !== "grid" && <Skeleton variant="text" width="50%" sx={typographyStyles.countryName} />}

        {/* Actions placeholder */}
        {variant !== "grid" && (
          <Box sx={{ display: "flex", gap: "8px", marginTop: "8px" }}>
            <Skeleton variant="rounded" width={80} height={36} />
            <Skeleton variant="rounded" width={80} height={36} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default UserCardLoader;
